import { addBreadcrumb } from '@sentry/browser';
import { useCallback } from 'react';

type SentryBreadcrumbCategory =
  | 'ui.click'
  | 'ui.press'
  | 'ui.select'
  | 'ui.check'
  | 'ui.uncheck'
  | 'ui.input'
  | 'ui.focus'
  | 'ui.blur'
  | 'navigation'
  | 'network'
  | 'user.action'
  | 'error';

export function useSentry() {
  // https://docs.sentry.io/product/issues/issue-details/breadcrumbs/
  // https://develop.sentry.dev/sdk/data-model/event-payloads/breadcrumbs/
  const useBreadcrumbs = () => {
    const addUserActionBreadcrumb = useCallback(
      (
        action: string,
        category: SentryBreadcrumbCategory = 'user.action',
        additionalData?: Record<string, any>,
      ) => {
        addBreadcrumb({
          category,
          message: action,
          level: 'info',
          data: additionalData,
        });
      },
      [],
    );

    return { addUserActionBreadcrumb };
  };

  return useBreadcrumbs();
}
